// Registers the PWA service worker in production builds only.
// Registering it in local dev causes the Service Worker to take control of
// the origin (e.g. 127.0.0.1:5173) and serve cached responses across dev
// server restarts and hard reloads, masking real code changes.
export function registerServiceWorker() {
    if (!import.meta.env.PROD) {
        return;
    }

    if ("serviceWorker" in navigator) {
        window.addEventListener("load", () => {
            navigator.serviceWorker
                .register("/sw.js")
                .then(registration => {
                    console.log("Service Worker registered:", registration.scope);
                })
                .catch(error => {
                    console.error("Service Worker registration failed:", error);
                });
        });
    }
}
